import { render, staticRenderFns } from "./LegalDocumentApplications.vue?vue&type=template&id=b1c7dcb8&scoped=true&"
import script from "./LegalDocumentApplications.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentApplications.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentApplications.vue?vue&type=style&index=0&id=b1c7dcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c7dcb8",
  null
  
)

export default component.exports